import { Flex, Typography } from '@aloft/toolkit-sui';

import { TrendsChartDataType } from '../utils/getHousingTrendsChartData.ts';

export const ZillowHomeValueIndexTrendsChartTooltip = ({
  active,
  payload,
}: {
  active: boolean;
  payload: {
    value?: number;
    dataKey?: string;
    name?: string;
    color?: string;
    payload?: TrendsChartDataType;
  }[];
}) => {
  const { payload: col } = payload.find((x) => x.dataKey === 'historical') ?? payload?.[0] ?? {};
  if (!active || col === undefined) return null;

  const {
    inner: { month, typicalValue, numCloses, affectedComps, percentChange },
  } = col;

  return (
    <Flex
      flexDirection="column"
      padding="1rem"
      backgroundColor="surface1"
      borderColor="strokeDefault"
      borderWidth="1px"
      borderStyle="solid"
    >
      <Typography variant="h4">{month}</Typography>
      {typicalValue !== undefined && (
        <Typography variant="body1">Median Close Price: {typicalValue.toString(true)}</Typography>
      )}
      {numCloses !== undefined && (
        <Typography variant="body1">Num. Closed Sales: {numCloses.toFixed(0)}</Typography>
      )}
      {percentChange !== undefined && (
        <Typography variant="body1">Date of Sale Adj: {`${percentChange.toFixed(2)}%`}</Typography>
      )}
      {affectedComps && <Typography variant="body1">Comps Affected: {affectedComps}</Typography>}
    </Flex>
  );
};
